export default __webpack_public_path__ + "static/busch-jaeger-excellence-79ddf7f3bee0652d1dc8e595b521b9a8.jpg";